import { assertedDefined } from '../../lib/util';
import useEvent from '../hooks/useEvent';
import type { ScenarioOrder } from '../../lib/planningData';
import type { ActiveModal } from '../contexts/ModalContext';

export function useOpenBatchEditCargoesModal({
  selectedOrderIds,
  scenarioOrderById,
  openModal,
}: {
  selectedOrderIds: number[];
  scenarioOrderById: Map<number, ScenarioOrder>;
  openModal: (modal: ActiveModal) => void;
}) {
  return useEvent((currentOrderId: number): void => {
    const orderIds =
      selectedOrderIds.length > 0 ? selectedOrderIds : [currentOrderId];
    const orders = orderIds.map((orderId) =>
      assertedDefined(
        scenarioOrderById.get(orderId),
        `expected order ${orderId} to exist for editing`,
      ),
    );

    openModal({
      type: 'BATCH_EDIT_CARGOES',
      props: {
        orders,
      },
    });
  });
}
